import { render, staticRenderFns } from "./AlertSubscriptionsList.vue?vue&type=template&id=2956f4e6&"
import script from "./AlertSubscriptionsList.vue?vue&type=script&lang=js&"
export * from "./AlertSubscriptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports